import moment from 'moment';
import {
  localeSort,
  dateStringSort,
} from '../utils/sort';
import RawRxHistory from '../models/raw-rx-history';
import {guessFileType, readFile, dumpTSVFile, parseCSVFile} from './file-utils';

const CSV_HEADERS = Object.keys(RawRxHistory.propTypes);

function normalizeBoolValue(value) {
  value = value.toLowerCase();
  return {
    true: 'Yes',
    false: 'No',
    yes: 'Yes',
    no: 'No'
  }[value] || 'No';
}


function normalizeDrugs(drugs) {
  if (drugs.toLowerCase() === 'none') {
    return 'None';
  }
  drugs = drugs.split(/\s*,\s*/g);
  return drugs.join(',');
}


function normalizeRxList(rxList) {
  return rxList.map(rxData => {
    rxData = Object.assign({}, rxData);
    rxData.startDate = moment.utc(rxData.startDate).format('YYYY-MM-DD');
    rxData.stopDate = moment.utc(rxData.stopDate).format('YYYY-MM-DD');
    rxData.orderUnknown = normalizeBoolValue(rxData.orderUnknown);
    rxData.durationUnknown = normalizeBoolValue(rxData.durationUnknown);
    rxData.drugs = normalizeDrugs(rxData.drugs);
    return rxData;
  });
}


export async function parseInputRxFile(file) {
  const fileContent = await readFile(file);
  const fileType = guessFileType(file, fileContent);
  let rows = [];
  if (fileType === 'tsv') {
    rows = parseCSVFile(fileContent, CSV_HEADERS, '\t', true);
  }
  else if (fileType === 'csv') {
    rows = parseCSVFile(fileContent, CSV_HEADERS, ',', true);
  }
  return normalizeRxList(rows);
}


export function exportRxFile(rxList, fileName = 'rx-datafile.txt') {
  return dumpTSVFile(rxList, CSV_HEADERS, fileName);
}


export function makeDefaultRxList(sequenceList) {
  // group isolates by patients
  let tracePrevIsolateDate = {};
  let traceUniquePatientIsolateDate = {};

  return sequenceList.filter((seq) => {
    const ptAlias = seq.ptAlias;
    const isolateDate = seq.isolateDate;
    const tracer = traceUniquePatientIsolateDate[ptAlias];

    if (tracer && tracer.includes(isolateDate)) {
      return false;
    } else {
      traceUniquePatientIsolateDate[ptAlias] = traceUniquePatientIsolateDate[ptAlias] || [];
      traceUniquePatientIsolateDate[ptAlias].push(isolateDate);
      return true;
    }
  }).sort((a, b) => {
    if (a.ptAlias === b.ptAlias) {
      return dateStringSort(a.isolateDate, b.isolateDate);
    } else {
      return localeSort(a.ptAlias, b.ptAlias);
    }
  }).map(
    (seqData) => {
      const {
        ptAlias, isolateDate, uuid} = seqData;

      let startDate = null;

      if (ptAlias in tracePrevIsolateDate) {
        startDate = tracePrevIsolateDate[ptAlias];
      } else {
        startDate = moment.utc(isolateDate).subtract(
          1, 'years').format('YYYY-MM-DD');
      }

      const stopDate = moment.utc(isolateDate).format('YYYY-MM-DD');
      tracePrevIsolateDate[ptAlias] = stopDate;

      if (ptAlias) {
        return {ptAlias, startDate, stopDate, rawSequenceUuid: uuid};
      } else {
        return {ptAlias: '', startDate, stopDate, rawSequenceUuid: uuid};
      }
    });
}

// export function makeDefaultRxList(sequenceList) {
//   // group isolates by patients
//   let keyType = null;
//   const patientIsolatesMap = sequenceList.reduce(
//     (acc, seqData) => {
//       const {
//         ptAlias, isolateName, isolateDateMatch, isolateDate, uuid} = seqData;
//       let key = ptAlias;
//       keyType = 'ptAlias';
//       if (!key) {
//         key = uuid;
//         keyType = 'UUID';
//       }
//       acc[key] = acc[key] || [];
//       acc[key].push({isolateName, isolateDateMatch, isolateDate, uuid});
//       return acc;
//     }, {}
//   );

//   return Object.entries(patientIsolatesMap).reduce(
//     (acc, [key, isolates]) => {
//       isolates = isolates.sort(
//         (a, b) => moment.utc(a.isolateDate).diff(moment.utc(b.isolateDate)));
//       const firstIsolate = isolates[0];
//       const lastIsolate = isolates[isolates.length - 1];
//       const rawSequenceUuid = isolates[0].uuid;
//       const startDate = (
//         moment.utc(firstIsolate.isolateDate)
//           .subtract(1, 'years').format('YYYY-MM-DD'));
//       const stopDate = lastIsolate.isolateDate;
//       if (keyType === 'ptAlias') {
//         const ptAlias = key;
//         acc.push({ptAlias, startDate, stopDate, rawSequenceUuid});
//       } else {
//         const ptAlias = '';
//         acc.push({ptAlias, startDate, stopDate, rawSequenceUuid});
//       }
//       return acc;
//     }, []
//   );
// }



// WEBPACK FOOTER //
// ./src/utils/rx-helper.js